import { createSelector } from 'reselect';

const getBenefits = (state) => state.loyaltyApp.benefits;
const getMembers = (state) => state.loyaltyApp.members;

export const getGlobalBenefits = createSelector(
    [getBenefits],
    (benefits) => {
        return benefits.filter(benefit => benefit.activation === "GLOBAL");
    }
);

export const getPersonalBenefits = createSelector(
    [getBenefits],
    (benefits) => {
        return benefits.filter(benefit => benefit.activation !== "GLOBAL");
    }
);

export const getLPMembers = createSelector(
    [getMembers],
    (members) => {
        return members.map(member => {
            if(!member.name) member.unregistered = true;
            return member;
        });
    }
);